import {ReduxRequest} from '../../core-utilities/redux-request';
import {BASE_REDUX_LIST_OPTIONS} from '../../config/redux-list';
import {getRefreshUser} from '../reducers/state';
import {baseReduxRequestOptions} from './requests';
import {REFRESH_USER_PREFIX} from './state';
import {buildLoginUserAjaxFactory} from './loginUser';

const reduxRequestOptions = {
  prefix: REFRESH_USER_PREFIX,
  getState: getRefreshUser,
  //  Uses the same path as login but with a different action payload and request body
  requestFactory: buildLoginUserAjaxFactory({
    ...BASE_REDUX_LIST_OPTIONS,
  }),
  buildRequest: buildBody,
  ...baseReduxRequestOptions,
};
/** @type {ReduxRequest} */
export const refreshUserRequest = new ReduxRequest(reduxRequestOptions);

function buildBody(state, payload) {
  return {
    grantType: 'refreshToken',
    include: ['firebaseToken'],
    refreshToken: payload.refreshToken,
  };
}



// WEBPACK FOOTER //
// ./src/js/auth/redux/refreshUser.js